export default __webpack_public_path__ + "static/Refrigeration_1-0f5f51e9fdb9338da86b6fcd930339b7.jpg";